module.exports = {
	"name": "Xbox One Chrome OSX Linux",
	"supported": [
		{
			"id": "©Microsoft Corporation Controller (STANDARD GAMEPAD Vendor: 045e Product: 028e)",
			"os": "Linux",
			"browser": "Chrome"
		},
		{
			"id": "Xbox One Controller (STANDARD GAMEPAD Vendor: 02d1 Product: 045e)",
			"os": "Mac OS X",
			"browser": "Chrome"
		}
	],
	"axes": {
		"left stick x": {
			"index": 0
		},
		"left stick y": {
			"index": 1
		},
		"right stick x": {
			"index": 2
		},
		"right stick y": {
			"index": 3
		}
	},
	"buttons": {
		"a": {
			"index": 0
		},
		"b": {
			"index": 1
		},
		"x": {
			"index": 2
		},
		"y": {
			"index": 3
		},
		"left shoulder": {
			"index": 4
		},
		"right shoulder": {
			"index": 5
		},
		"left stick": {
			"index": 10
		},
		"right stick": {
			"index": 11
		},
		"dpad left": {
			"index": 14
		},
		"dpad right": {
			"index": 15
		},
		"dpad up": {
			"index": 12
		},
		"dpad down": {
			"index": 13
		},
		"left stick left": {
			"axis": 0,
			"direction": -1
		},
		"left stick right": {
			"axis": 0,
			"direction": 1
		},
		"left stick up": {
			"axis": 1,
			"direction": -1
		},
		"left stick down": {
			"axis": 1,
			"direction": 1
		},
		"left trigger": {
			"index": 6
		},
		"right trigger": {
			"index": 7
		},
		"right stick left": {
			"axis": 2,
			"direction": -1
		},
		"right stick right": {
			"axis": 2,
			"direction": 1
		},
		"right stick up": {
			"axis": 3,
			"direction": -1
		},
		"right stick down": {
			"axis": 3,
			"direction": 1
		},
		"back": {
			"index": 8
		},
		"start": {
			"index": 9
		},
		"home": {
			"index": 16
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/html5-gamepad/mappings/xbone-chrome-osx-linux.json
// module id = 215
// module chunks = 0